var _circle, _path, _path2, _path3, _path4, _path5, _mask, _g, _circle2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _path20, _path21, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWcsDeclined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 58.5,
    r: 58.5,
    fill: "#F3EFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 42.0003C31.0755 41.7739 31.1595 41.5561 31.2525 41.3466C32.2285 38.2521 30.2682 34.9022 27 33.5015C31.5 34.0015 34.6667 30.6667 35.5 29C34 33.5015 37.3333 36.1659 39.5 36.9988C34.8774 37.4622 32.3917 38.7805 31.2525 41.3466C31.1833 41.566 31.0993 41.7842 31 42.0003Z",
    fill: "#169F54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66.0003C95.0755 65.7739 95.1595 65.5561 95.2525 65.3466C96.2285 62.2521 94.2682 58.9022 91 57.5015C95.5 58.0015 98.6667 54.6667 99.5 53C98 57.5015 101.333 60.1659 103.5 60.9988C98.8774 61.4622 96.3917 62.7805 95.2525 65.3466C95.1833 65.566 95.0993 65.7842 95 66.0003Z",
    fill: "#DAD6DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 23.5C84.7 25.5 80.3333 22 79 20C80.2 26.8 75.5 29.8333 73 30.5C79 31.3 80.1667 37.5 80 40.5C84 34.5 90.3333 35 93 36C89 32.8 90.3333 26.3333 91.5 23.5Z",
    fill: "#D9D6DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.52 36C81.5864 35.8085 81.6604 35.6241 81.7422 35.4468C82.6011 32.8285 80.876 29.994 78 28.8089C81.96 29.2319 84.7467 26.4102 85.48 25C84.16 28.8089 87.0933 31.0633 89 31.7681C84.9322 32.1601 82.7447 33.2756 81.7422 35.4468C81.6813 35.6325 81.6074 35.8171 81.52 36Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18.5C55 20.433 53.433 22 51.5 22C49.567 22 48 20.433 48 18.5C48 16.567 49.567 15 51.5 15C53.433 15 55 16.567 55 18.5Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 117,
    height: 117
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 58.5,
    fill: "#F3EFF3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 56.5,
    r: 9.5,
    fill: "#D9D5DA"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 56.5,
    r: 3.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7884 74.3584L45.4909 113.601C45.4909 113.601 45.1466 115.981 46.9145 115.981C49.8213 115.988 61.3756 115.981 61.3756 115.981C61.3756 115.981 59.1905 115.484 59.217 114.37C59.2501 113.057 63.0707 73.9805 63.0707 73.9805L48.7884 74.3584Z",
    fill: "#9B9D9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4622 115.285C61.8928 115.285 50.7026 115.305 47.8753 115.272C46.6437 115.258 46.4252 114.171 46.4186 113.475C46.412 113.136 46.4583 112.891 46.4583 112.891L46.5444 111.87L46.7629 109.27L46.9549 106.976L47.1999 104.025L47.4118 101.532L49.7558 73.6487L64.0315 73.2773C64.0315 73.2773 62.4225 89.6294 61.2836 101.532C61.1578 102.858 61.0386 104.131 60.926 105.318C60.8929 105.696 60.8532 106.068 60.8201 106.426C60.7142 107.553 60.6148 108.587 60.5354 109.503C60.489 109.987 60.4493 110.431 60.4162 110.842C60.2705 112.447 60.1844 113.475 60.1844 113.667C60.1844 113.78 60.1911 113.886 60.2109 113.985C60.4361 115.232 62.2437 115.285 62.4622 115.285Z",
    fill: "#CECECD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1123 53.0078L22.1374 85.2942L23.2366 89.7171L26.9776 104.756H96.4425L82.6568 53.0078H14.1123Z",
    fill: "#CECECD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1124 53L13 53.3713L25.5012 105.882L26.9777 104.755L14.1124 53Z",
    fill: "#9B9D9B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.501 105.881H94.5355L96.4424 104.754H26.9775L25.501 105.881Z",
    fill: "#B0B1B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.745 116H64.6895V115.29H49.745V116Z",
    fill: "#CECECD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8925 105.883L60.813 106.427L46.7559 109.271L46.9479 106.97L47.0406 105.883H60.8925Z",
    fill: "#9B9D9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4616 115.285C61.8921 115.285 50.702 115.305 47.8747 115.272C46.6431 115.259 46.4246 114.171 46.418 113.475L60.4089 110.836C60.2633 112.441 60.1772 113.468 60.1772 113.661C60.1772 113.773 60.1838 113.88 60.2037 113.979C60.4354 115.232 62.2431 115.285 62.4616 115.285Z",
    fill: "#9B9D9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1123 53H82.6568L93.7807 94.5963H24.4549L14.1123 53Z",
    fill: "#CECECD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5497 92.7924H26.3687L24.0777 83.6483L23.1905 80.1073L22.8263 78.6617L20.4691 69.259L20.3433 68.7683L19.0985 63.8016L18.5423 61.5736L18.0655 59.6772L16.9531 55.2344H80.2071L81.4321 59.6772L81.9552 61.5736L82.5643 63.8016L86.5968 78.4495L86.9411 79.6895L87.1 80.2664L89.881 90.3854L90.5497 92.7924Z",
    fill: "#9B9D9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4321 59.676H18.0655L16.9531 55.2266H80.2071L81.4321 59.676Z",
    fill: "#787A78"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5678 57.2406C19.4883 56.9356 19.6803 56.6836 19.9849 56.6836C20.2895 56.6836 20.6007 56.9356 20.6802 57.2406C20.7596 57.5456 20.5676 57.7976 20.263 57.7976C19.9584 57.7976 19.6472 57.5456 19.5678 57.2406Z",
    fill: "#E9F3FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4154 57.2406C21.336 56.9356 21.528 56.6836 21.8326 56.6836C22.1372 56.6836 22.4484 56.9356 22.5278 57.2406C22.6073 57.5456 22.4153 57.7976 22.1107 57.7976C21.7995 57.791 21.4883 57.5456 21.4154 57.2406Z",
    fill: "#E9F3FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4018 57.2406C23.3223 56.9356 23.5143 56.6836 23.8189 56.6836C24.1235 56.6836 24.4347 56.9356 24.5142 57.2406C24.5936 57.5456 24.4016 57.7976 24.097 57.7976C23.7924 57.7976 23.4746 57.5456 23.4018 57.2406Z",
    fill: "#E9F3FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 94.5,
    r: 21.5,
    fill: "#599944"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 73C86.7978 73 81.3292 75.2652 77.2972 79.2972C73.2652 83.3292 71 88.7978 71 94.5C71 100.202 73.2652 105.671 77.2972 109.703C81.3292 113.735 86.7978 116 92.5 116L92.5 94.5V73Z",
    fill: "#76CC5B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0006 92.1436C84.9969 92.2304 85.011 92.317 85.042 92.3982C85.0731 92.4793 85.1204 92.5532 85.1811 92.6154C85.2417 92.6776 85.3145 92.7267 85.3948 92.7597C85.4752 92.7927 85.5614 92.809 85.6483 92.8074H87.8654C88.2363 92.8074 88.5319 92.5038 88.5803 92.1356C88.8222 90.3726 90.0316 89.0879 92.1869 89.0879C94.0306 89.0879 95.7183 90.0098 95.7183 92.2269C95.7183 93.9335 94.7132 94.7183 93.1249 95.9115C91.3162 97.2257 89.8838 98.7603 89.9859 101.252L89.9939 101.835C89.9968 102.011 90.0688 102.179 90.1945 102.303C90.3202 102.427 90.4895 102.496 90.6658 102.496H92.8454C93.0236 102.496 93.1945 102.425 93.3205 102.299C93.4465 102.173 93.5173 102.002 93.5173 101.824V101.542C93.5173 99.6122 94.2509 99.0505 96.2316 97.5482C97.8683 96.3039 99.5749 94.9225 99.5749 92.0227C99.5749 87.9619 96.1456 86 92.3912 86C88.9861 86 85.2559 87.5856 85.0006 92.1436ZM89.185 107.632C89.185 109.064 90.3272 110.123 91.8994 110.123C93.5361 110.123 94.6621 109.064 94.6621 107.632C94.6621 106.148 93.5334 105.105 91.8967 105.105C90.3272 105.105 89.185 106.148 89.185 107.632Z",
    fill: "#DFDFE1"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 73,
    width: 22,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5 73C86.7978 73 81.3292 75.2652 77.2972 79.2972C73.2652 83.3292 71 88.7978 71 94.5C71 100.202 73.2652 105.671 77.2972 109.703C81.3292 113.735 86.7978 116 92.5 116L92.5 94.5V73Z",
    fill: "#76CC5B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0006 92.1436C84.9969 92.2304 85.011 92.317 85.042 92.3982C85.0731 92.4793 85.1204 92.5532 85.1811 92.6154C85.2417 92.6776 85.3145 92.7267 85.3948 92.7597C85.4752 92.7927 85.5614 92.809 85.6483 92.8074H87.8654C88.2363 92.8074 88.5319 92.5038 88.5803 92.1356C88.8222 90.3726 90.0316 89.0879 92.1869 89.0879C94.0306 89.0879 95.7183 90.0098 95.7183 92.2269C95.7183 93.9335 94.7132 94.7183 93.1249 95.9115C91.3162 97.2257 89.8838 98.7603 89.9859 101.252L89.9939 101.835C89.9968 102.011 90.0688 102.179 90.1945 102.303C90.3202 102.427 90.4895 102.496 90.6658 102.496H92.8454C93.0236 102.496 93.1945 102.425 93.3205 102.299C93.4465 102.173 93.5173 102.002 93.5173 101.824V101.542C93.5173 99.6122 94.2509 99.0505 96.2316 97.5482C97.8683 96.3039 99.5749 94.9225 99.5749 92.0227C99.5749 87.9619 96.1456 86 92.3912 86C88.9861 86 85.2559 87.5856 85.0006 92.1436ZM89.185 107.632C89.185 109.064 90.3272 110.123 91.8994 110.123C93.5361 110.123 94.6621 109.064 94.6621 107.632C94.6621 106.148 93.5334 105.105 91.8967 105.105C90.3272 105.105 89.185 106.148 89.185 107.632Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcsDeclined);
export default __webpack_public_path__ + "static/media/wcs-declined.26c179cc.svg";
export { ForwardRef as ReactComponent };